export enum eCurativeGradeType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export enum ePrettyCurativeGradeType {
  A = 'Grade A',
  B = 'Grade B',
  C = 'Grade C',
  D = 'Grade D',
}
